import React, { useState } from 'react'
import { Tooltip } from 'primereact/tooltip'
import './data.scss'
import LuxIcon from '../icons/LuxIcon'

const BadgeIcon = (props: {
    iconName: string
    color: string
    backgroundColor?: string
    tooltip?: string
    size?: number
}) => {
    // backgroundColor can be used to specify the color on which
    // the badge is placed, providing a transparency effect
    // console.log('iconprops', props)

    // TMP icon names mapping
    let iconName = ''
    switch (props.iconName) {
        case 'check_circle':
            iconName = ' cu cu-check-circle'
            break
        case 'public':
            iconName = ' cu cu-globe'
            break
        case 'warning':
            iconName = ' cu cu-exclamation-triangle'
            break
        case 'cancel':
            iconName = 'times-circle'
            break
        case 'camera_alt':
            iconName = ' cu cu-camera'
            break
        default:
            iconName = props.iconName
            break
    }

    return (
        <span
            className="status-icon-badge mr-2 p-0"
            data-pr-tooltip={props.tooltip}
            style={{ backgroundColor: props.backgroundColor }}>
            <LuxIcon
                icon={iconName}
                size={props.size ? props.size : undefined}
                color={props.color ? props.color : 'white'}
            />
            <Tooltip
                target={'.status-icon-badge'}
                mouseTrack
                mouseTrackLeft={10}
            />
        </span>
    )
}

export default BadgeIcon
